module.exports = __webpack_public_path__ + "./img-james_6ec8157c8199ee683023772376d6fbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-james.png
// module id = 464
// module chunks = 0